import Api from './Api';
import Configuracao from '../util/Configuracao';

class CarenciaApi extends Api {
  async consultar (beneficiario) {
    const { codServidor, codTipoMensalidade, seqBeneficiario, seqDependente, numSeqDependenteRH } = beneficiario;
    try {
      const url = Configuracao.getConfiguracao().urlCarenciaConsultar +
        `/${codTipoMensalidade}` +
        `/${codServidor}` +
        `/${seqBeneficiario}` +
        `${numSeqDependenteRH !== null ? `?numSeqDependenteRH=${numSeqDependenteRH}` : ''}` +
        `${numSeqDependenteRH !== null ? `&seqDependente=${seqDependente}` : ''}`;

      const response = await this.fetch(url);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async salvar (carencias) {
    const url = Configuracao.getConfiguracao().urlCarenciaSalvar;
    const pCarencias = carencias.map(async carencia => {
      return this.fetch(url, 'POST', carencia, { 'content-type': 'application/json' });
    });
    await Promise.all(pCarencias);
  }
}

export default CarenciaApi;
